module.exports = __webpack_public_path__ + "media/images/general/logo-835015112bdba3eb3dd0437cbd3b0d79.svg";